import React from 'react'

import { LanguageProvider } from './context/LanguageContext'
import Header from './components/header/Header'
import Navbar from './components/nav/Navbar'
import Skills from './components/skills/Skills'
import Projects from './components/projects/Projects'
import Services from './components/services/Services'
import Contact from './components/contact/Contact'
import Footer from './components/footer/Footer'


function App() {
  return (
    <LanguageProvider>
      <Header />
      <Navbar />
      <Skills />
      <Projects />
      <Services />
      <Contact />
      <Footer />
    </LanguageProvider>
  );
}

export default App;
